import { createContext } from 'react';

interface TabsContextType {
  selectedTabIndex: number;
  onSelectTab: (index: number) => void;
  fileCount: number;
  commitCount: string;
}

/**
 * Creates a React context for the PR tabs state and handlers to be
 * used with the @atlaskit/tabs component(s).
 *
 * The context value provides the selected tab index,
 * a callback to change the selected tab, and the
 * file/commit counts.
 */
export const TabsContext = createContext<TabsContextType>({
  selectedTabIndex: 0,
  onSelectTab: () => {},
  fileCount: 0,
  commitCount: '0',
});
